export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Translations.json?hash=fb7db495e6e9ff44951a781820880a6f";